import React, { useState, useCallback, forwardRef, useImperativeHandle } from "react";
import { ICategory, IOrg, isCategory } from "../../../types/org";
import OrgTreeItem from "./org-tree-item"
import './org-tree.scss';

type OrgTreeProps = {
    roots: ICategory[];
    isGlobal: boolean;
    onSelected: (item?: ICategory | IOrg) => void;
    selectOrgOnly?: boolean;
    orgPathIds?: number[];
    inOrgId?: number;
}

const OrgTree = forwardRef((props: OrgTreeProps, ref: React.Ref<any>) => {
    const { roots, isGlobal, onSelected, selectOrgOnly, orgPathIds, inOrgId } = props;
    const [selectedItem, setSelectedItem] = useState<ICategory | IOrg>();

    // Initialize orgItemRefs separately
    const orgItemRefs: React.RefObject<any>[] = [];

    const selectItem = (item: ICategory | IOrg) => {
        
        setSelectedItem(item);
        onSelected(item);
    }

    const isSelected = useCallback((item: ICategory | IOrg) => {
        const isDirectlySelected = item.id === selectedItem?.id;
        const isPassIn = inOrgId == item.id ?? false;
        return isDirectlySelected || isPassIn;
    }, [selectedItem, orgPathIds]);

    useImperativeHandle(ref, () => ({
        refresh() {
            orgItemRefs?.forEach((orgItemRef) => orgItemRef.current.refresh());
        }
    }));

    const selectedItemLive = () => {
        return 'Selected ' + (isCategory(selectedItem) ? selectedItem?.categoryName : selectedItem?.orgName)
    }

    return (
        <>
            <div
                aria-live="assertive"
                style={{
                    position: "absolute",
                    width: '1px',
                    height: '1px',
                    margin: '-1px',
                    border: '0',
                    padding: '0',
                    clip: 'rect(0, 0, 0, 0)',
                    overflow: 'hidden'
                }}
            >
                {selectedItemLive()}
            </div>
            <ul className="org-tree" role="tree">
                {
                    roots?.map((category, i) => {
                        // Create a new ref for each OrgTreeItem and push it to the array
                        const orgItemRef = React.createRef();
                        orgItemRefs.push(orgItemRef);

                        return (
                            <OrgTreeItem
                                key={category.id}
                                category={category}
                                isSelected={isSelected}
                                onSelected={selectItem}
                                isGlobal={isGlobal}
                                selectOrgOnly={selectOrgOnly}
                                ref={orgItemRef}
                                orgPathIds={orgPathIds}
                            ></OrgTreeItem>
                        );
                    })
                }
            </ul>
        </>
    )
})

export default OrgTree;
